import {
  profileResponseSchema,
  profileSchema,
  type Profile,
  type ProfilePatch,
  type ProfileResponse,
} from '../../shared/api';
import { API_PATHS } from '../../shared/routes';
import { fetchJson } from './http';

/** Issue a credential, carrying any identity this browser already collected. */
export function issueProfile(identity: ProfilePatch = {}): Promise<ProfileResponse> {
  return fetchJson(profileResponseSchema, API_PATHS.profile, { method: 'POST', json: identity });
}

export function readProfile(credential: string): Promise<Profile> {
  return fetchJson(profileSchema, API_PATHS.profile, { credential });
}

export function updateProfile(credential: string, patch: ProfilePatch): Promise<Profile> {
  return fetchJson(profileSchema, API_PATHS.profile, { method: 'PUT', credential, json: patch });
}
